// extracted by css-extract-rspack-plugin
export default {"Box":"Table-module__Box__HZKiQ","Box_1":"Table-module__Box_1__VacXC","Box_2":"Table-module__Box_2__PBp9s","Box_3":"Table-module__Box_3__d9lz1","Box_4":"Table-module__Box_4__hvL1K"};